import { jsx as _jsx } from "react/jsx-runtime";
import { Redirect } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
var OldPushNotifications = function () {
    var history = useHistory();
    var pathname = history.location.pathname;
    var pathNameArray = pathname.split('/');
    var orgId = pathNameArray[2];
    var appId = pathNameArray[4];
    var createPage = pathNameArray[6] === 'new';
    return createPage ? (_jsx(Redirect, { to: "/organizations/".concat(orgId, "/apps/").concat(appId, "/push/notifications/new") })) : (_jsx(Redirect, { to: "/organizations/".concat(orgId, "/apps/").concat(appId, "/push/notifications") }));
};
export default OldPushNotifications;
